import { ICrudLocale } from '@app/i18n/interface';

export const HOTEL_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  HOTEL: {
    LABEL: {
      SINGULAR: 'Hotel',
      PLURAL: 'Hotels',
    },
    FIELD: {
      DESTINATION: 'Destination',
      DESTINATION_PLACEHOLDER: 'City, area or hotel name',
      CHECK_IN: 'Check-in',
      CHECK_OUT: 'Check-out',
      DATE_PLACEHOLDER: 'dd/mm/yyyy',
      ROOMS: 'Rooms',
      ROOMS_ONE: '1 room',
      ROOMS_N: '{{n}} rooms',
      ADULTS: 'Adults per room',
      ADULTS_ONE: '1 adult',
      ADULTS_N: '{{n}} adults',
      CHILDREN: 'Children per room',
      CHILDREN_ONE: '1 child',
      CHILDREN_N: '{{n}} children',
      CHILD_AGE: 'Age of child {{n}}',
      CHILD_AGE_PLACEHOLDER: 'Choose the age',
      AGE_BABY: 'Baby (under 1)',
      AGE_ONE: '1 year',
      AGE_N: '{{n}} years',
      SOURCE_MARKET: 'Country of origin',
      HOTEL_CODES: 'Specific hotels (optional)',
      HOTEL_CODES_PLACEHOLDER: 'For example 113657, 357246',
      HOTEL_CODES_HELP: 'If you fill this in, only those hotels are searched, separated by commas.',
      BOARD: 'Board',
      PRICE: 'Sale price',
      RATE_KEY: 'Rate key (rateKey)',
      CANCEL_FREE_ALWAYS: 'Free cancellation (no tier charges)',
      CANCEL_FREE_UNTIL: 'Free until {{date}}{{utc}}',
      CANCEL_THEN: 'then {{amount}}',
      CANCEL_EXPIRED: 'already closed',
      CANCEL_UNKNOWN: 'Cancellation: not reported by the provider',
    },
    SEARCH: {
      TITLE: 'Hotel search',
      SUBTITLE: 'Check the availability and the rates the customer sees, without going through the public website.',
      FORM_TITLE: 'Search details',
      FORM_SUBTITLE: 'Each search is a real availability request to Hotelbeds.',
      SUBMIT: 'Search',
      SEARCHING_BUTTON: 'Searching',
      RESET: 'Clear',
      SEARCHING: 'Searching…',
      NO_MATCHES: 'No matches',
      GROUP_DESTINATIONS: 'Destinations',
      GROUP_HOTELS: 'Hotels',
      CLEAR_LOCATION: 'Clear the destination',
      SUGGESTIONS: 'Destination and hotel suggestions',
    },
    RESULTS: {
      TITLE: 'Results',
      CAPTION: 'Hotels with availability',
      SUMMARY: '{{hotels}} available for {{nights}}, {{guests}} and {{rooms}}. Prices in {{currency}}.',
      HOTELS_ONE: '1 hotel',
      HOTELS_N: '{{n}} hotels',
      NIGHTS_ONE: '1 night',
      NIGHTS_N: '{{n}} nights',
      LOADING: 'Checking availability with Hotelbeds',
      LOADING_HINT: 'It may take a few seconds. Results will show up here.',
      COL_HOTEL: 'Hotel',
      COL_DESTINATION: 'Destination',
      COL_CATEGORY: 'Category',
      COL_BOARD: 'Board of the lowest rate',
      COL_BOARD_SHORT: 'Board',
      FROM: 'From',
      RATES: '{{n}} rates',
      RATES_ONE: '1 rate',
      CODE: 'Code {{code}}',
      STARS: '{{n}} stars',
      BOARD_FILTER: 'Board',
      BOARD_ANY: 'Any board',
      PAGINATION: 'Result pages',
      SHOWING: 'Showing {{from}}-{{to}} of {{total}}',
      PAGE: 'Page {{page}} of {{pages}}',
      PREVIOUS: 'Previous',
      NEXT: 'Next',
      EMPTY: 'No hotels available for that search. Try other dates or another destination.',
      ERROR_TITLE: 'Availability could not be checked',
      ERROR: 'Try again in a moment. If it keeps failing, tell the technical team.',
    },
    VALIDATION: {
      DATES_REQUIRED: 'Choose the check-in and check-out dates.',
      CHECKOUT_AFTER_CHECKIN: 'Check-out must be after check-in.',
      TOO_MANY_NIGHTS: 'You can search up to 30 nights.',
      TOO_MANY_GUESTS: 'Up to 5 people fit in a room.',
      CHILD_AGES: 'Give the age of each child.',
      DESTINATION_OR_CODES: 'Choose a destination or hotel from the list, or type a hotel code.',
    },
  },
};
